import { push } from "connected-react-router";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

const NoServices = ({ push }) => (
  <div className="p-card--highlighted u-no-margin--bottom">
    <h4>Add a service</h4>
    <p>
      You need at least one service to use RBAC. You can add one now, or at a
      later time by clicking the Add button in the Services column.
    </p>
    <div className="l-flex-spaced-centered">
      <button
        className="u-no-margin--bottom"
        type="button"
        onClick={() => push("/policies")}
      >
        Close
      </button>
      <button
        className="p-button--positive u-no-margin--bottom"
        type="button"
        onClick={() => push("/policies/services/add")}
      >
        Add service
      </button>
    </div>
  </div>
);

NoServices.propTypes = {
  push: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  push
};

export default connect(
  undefined,
  mapDispatchToProps
)(NoServices);
